import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { SecurityService } from '../core/auth/security.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  loginForm: FormGroup;

  error: any;

  constructor(
    private formBuilder: FormBuilder,
    private securityService: SecurityService
  ) { }

  ngOnInit(): void {
    this.securityService.logout();

    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  login(): void {
    const username = this.loginForm.get('email').value;
    const password = this.loginForm.get('password').value;

    this.securityService.login(username, password)
      .pipe(catchError(error => {
        this.loginForm.reset();
        this.error = error;
        return error;
      }))
      .subscribe(ok => {
        if (ok) {
          this.securityService.returnToTargetPage();
        }
      });
  }

}
